<template>
  <div class="main">
    <div class="shopmall-back">
      <div class="shopmall-header">
        <div class="shopmall-info">
          <div class="shopmall-info-img">
            <img :src="logoImg">
          </div>
          <div class="shopmall-info-box">
            <div class="info-box-title">{{stName}}</div>
            <div class="info-box-star">
              <div class="store-start">
                <div class="start" v-if="starClass == 1"><span>店铺星级</span>★☆☆☆☆</div>
                <div class="start" v-if="starClass == 2"><span>店铺星级</span>★★☆☆☆</div>
                <div class="start" v-if="starClass == 3"><span>店铺星级</span>★★★☆☆</div>
                <div class="start" v-if="starClass == 4"><span>店铺星级</span>★★★★☆</div>
                <div class="start" v-if="starClass == 5"><span>店铺星级</span>★★★★★</div>
              </div>
            </div>
            <div class="info-box-data">
              <div class="data-flex">
                <span>评价</span>
                <strong>{{appraise}}</strong>
              </div>
              <div class="data-flex">
                <span>物流</span>
                <strong>{{deliveryAppraise}}</strong>
              </div>
              <div class="data-flex">
                <span>售后</span>
                <strong>{{afterSalesAppraise}}</strong>
              </div>
            </div>
          </div>
        </div>
        <div class="shopmall-tips">
          <div class="tips-title">
            <van-divider :style="{ color: '#181818', borderColor: '#181818', fontWeight: 'bold', padding: '0 0.1rem', width: '1.5rem' }">店铺公告</van-divider>
          </div>
          <div class="tips-box">
            <div class="tips-img">
              <img src="../assets/shopmallimg/tips.svg">
            </div>
            <div class="tips-text">本店入驻好兽药商城，所有商品一律包邮本店入驻 好兽药商城，所有商品一律包邮</div>
          </div>
        </div>
      </div>
    </div>
    <div class="shopmall-list">

      <div class="shopmall-navbar">
        <div class="navbar" @click="navbar(1)" :class="navnumber==1 ? 'barcolor':''">综合</div>
        <div class="navbar" @click="navbar(2)" :class="navnumber==2 ? 'barcolor':''">销量</div>
        <div class="navbar" @click="navbar(3)" :class="navnumber==3 ? 'barcolor':''">
          <span>价格</span>
          <i class="stortop" :class="pricenumber==1 ? 'topcolor':''"></i>
          <i class="storbottom" :class="pricenumber==2 ? 'bottomcolor':''"></i>
        </div>
      </div>

      <van-list v-model="loading" :finished="finished" :immediate-check="false" finished-text="没有更多了" @load="onLoad" :offset="10">
        <van-cell v-for="item in goodsList" :key="item.stId">
          <div class="shopmall-box">
            <div class="shopmall-img">
              <img :src="item.pictureUrl" alt="">
            </div>
            <div class="shopmall-info">
              <div class="shopmall-title">{{item.goodsName}}</div>
              <div class="shopmall-flex">
                <div class="shopmall-price">
                  ￥<span>{{item.retailPrice}}</span>
                  <!-- <strong>￥{{}}</strong> -->
                </div>
                <div class="shopmall-number">已售{{item.salesTotal}}件</div>
                <div class="shopmall-company">
                  <div class="company-img">
                    <img src="../assets/shopmallimg/shopmall.svg" alt="">
                  </div>
                  <div class="company-text">{{item.orgName}}</div>
                </div>
              </div>
            </div>
          </div>
        </van-cell>
      </van-list>
    </div>
    <div class="shopmall-height"></div>
    <div class="shopmall-app">
      <div class="msgbox-botton" v-if="openPopup == true">
        <span>打开好兽药APP,<strong>查看更多精彩</strong></span>
        <wx-open-launch-app class="launch-btn" :id="id" :appid="appid" :extinfo="wechatOpenAppData">
          <script type="text/wxtag-template">
            <style>.btn {height: 45px;}</style>
            <div class="btn">打开APP</div>
          </script>
        </wx-open-launch-app>
      </div>
      <div class="app-img" @click="openApp" v-else><img src="../assets/shopmallimg/app.svg"></div>
    </div>
    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
    <Top :btnFlag="btnFlag"/>
  </div>
</template>

<script>
  import Top from '@/components/top.vue'
  import { iswx, wxshare } from '@/utils/utils.js'
  import { findStoreByOrganId } from '@/api/resetApi.js'
  export default {
    name: 'App',
    components: {
      Top
    },
    data () {
      return {
        page: 1,
        organId: '',
        sortBy: '',
        pricenumber: '',

        navnumber: 1,
        logoImg: '',
        stName: '',
        starClass: '',
        appraise: '',
        deliveryAppraise: '',
        afterSalesAppraise: '',
        title: '',
        goodsList: [],

        loading: false,
        finished: false,
        openPopup: false,
        btnFlag:false,
        sell: false,

        id: 'wxopenLanchAppId',
        appid: 'wxbaafb4b97fb87904',
        wechatOpenAppData: '',
        json: {},

        show: false,
        actions: [{ name: '综合排序' }, { name: '新品优先' }, { name: '好评优先' }],
      }
    },
    created() {
      this.organId = this.$route.query.organId
      //加载商铺 OG201911022029355432
      this.shopmall();
      //微信打开APP
      this.json = {
        "type": "shop",
        "organId": this.organId
      }
      this.wechatOpenAppData = JSON.stringify(this.json)
      if (iswx() === true) {
        let wechat = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
        console.log('wechat',wechat)
        let judgewechat = wechat[1].split('.')
        if(judgewechat[0]>=7){
          if(judgewechat[1]>=0){
            if(judgewechat[2]>=12){
              this.openPopup = true
              console.log("当前符合 h5 打开指定app")                    
            }
          }
        }
      }
    },
    mounted() {
      if (this.openPopup == true) {
        var btn = document.getElementById(this.id)
        btn.addEventListener('launch', e => {
          console.log('success');
        });
        btn.addEventListener('error',  e => {
          this.text = e.detail.errMsg
          if (e.detail.errMsg == 'launch:fail') {
            window.location = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.sslab.customer'
          } else {
            this.$createToast({
              txt: e.detail,
              type: 'error'
            }).show()
          }
        });
      }
    },
    methods: {
      async shopmall(){
        let data = {
          size: 10,
          page: this.page,
          organId: this.organId,
          sortBy: parseInt(this.sortBy),
        }
        const res = await findStoreByOrganId(data)
        console.log(res)
        try {
          if (res.data.code === 200) {
            this.logoImg = res.data.data.logoImg
            this.stName = res.data.data.stName
            this.starClass = res.data.data.starClass
            this.appraise = res.data.data.appraise
            this.deliveryAppraise = res.data.data.deliveryAppraise
            this.afterSalesAppraise = res.data.data.afterSalesAppraise
            this.title = '我在好兽药上发现了一个店铺，快来看看吧'
            this.loading = false;
            if (res.data.data.goodsList == null || res.data.data.goodsList.length === 0) {
              // 加载结束
              this.finished = true;
              return;
            }
            // 将新数据与老数据进行合并
            this.goodsList = this.goodsList.concat(res.data.data.goodsList);
            wxshare(this.logoImg,this.stName,this.title);
          } else {
            this.$createToast({
              txt: res.data.msg,
              type: 'error'
            }).show()
          }
        } catch (error) {}
      },
      // 打开APP
      openApp() {
        window.location = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.sslab.customer'
      },
      onLoad() {
        this.page++;
        this.shopmall();
      },
      onSelect(item) {
        // 默认情况下点击选项时不会自动收起
        // 可以通过 close-on-click-action 属性开启自动收起
        this.navnumber = this.sell
        this.pricenumber = ''
        if (item.name == '综合排序') {
          this.sortBy = 1
        } else if (item.name == '新品优先') {
          this.sortBy = 2
        } else if (item.name == '好评优先') {
          this.sortBy = 3
        }
        this.goodsList = []
        this.page = 1
        this.shopmall()
        this.show = false;
        console.log(item.name)
      },
      navbar(type) {
        if (parseInt(type) == 1) {
          this.sell = parseInt(type)
          this.sortBy = 1
          this.show = true
          return
        } else if (parseInt(type) == 2) {
          this.navnumber = parseInt(type)
          this.pricenumber = ''
          this.sortBy = 4
        } else if (parseInt(type) == 3) {
          this.navnumber = parseInt(type)
          if (this.pricenumber == '') {
            this.pricenumber = 1
            this.sortBy = 5
          } else if (this.pricenumber == 1) {
            this.pricenumber = 2
            this.sortBy = 6
          } else if (this.pricenumber == 2) {
            this.pricenumber = 1
            this.sortBy = 5
          }
          console.log('this.pricenumber',this.pricenumber)
        }
        this.goodsList = []
        this.page = 1
        this.shopmall()
      }
    }
  }
</script>

<style lang="scss">
  .main {
    max-width: 768px;
    margin: 0 auto;
    font-size: 0;
    .van-divider {
      margin: 0.16rem 0;
      font-size: 0.14rem;
    }
    .van-cell {
      line-height: 0.15rem;
    }
    // background: #f7f7f7;
    .shopmall-header {
      width: 3.75rem;
      height: 2.5rem;
      background: url(../assets/shopmallimg/back.svg) no-repeat;
      background-size: 100% 100%;
      .shopmall-info {
        padding: 20px 10px 0;
        display: flex;
        .shopmall-info-img {
          flex: 0 0 0.4rem;
          img {
            width: 0.4rem;
            height: 0.4rem;
          }
        }
        .shopmall-info-box {
          flex: 1;
          padding-left: 0.1rem;
          .info-box-title {
            text-align: left;
            font-size: 0.16rem;
            font-weight: bold;
            color: #fff;
          }
          .info-box-star {
            padding: 10px 0;
            text-align: left;
            .store-start {
              display: inline-block;
              padding: 0.02rem 0.1rem 0.01rem;
              line-height: 0.2rem;
              text-align: center;
              background: #f7f7f7;
              border-radius: 0.1rem;
              .start {
                font-size: 0.14rem;
                color: #EA4747;
                span {
                  margin-right: 0.05rem;
                  font-size: 0.12rem;
                  color: #818181;
                }
              }
            }
          }
          .info-box-data {
            display: flex;
            .data-flex {
              flex: 1;
              padding: 15px 0;
              text-align: left;
              span {
                font-size: 0.12rem;
                color: #fff;
              }
              strong {
                margin-left: 0.05rem;
                font-size: 0.16rem;
                font-weight: bold;
                color: #fff;
              }
            }
          }
        }
      }
      .shopmall-tips {
        display: inline-block;
        width: 3.55rem;
        height: 1.2rem;
        background: #fff;
        box-shadow:  0 0.02rem 0.08rem 0  rgba(190,190,190,0.6); ;
        border-radius: 0.06rem;
        font-size: 0;
        text-align: center;
        .tips-title {
          display: inline-block;
        }
        .tips-box {
          display: flex;
          .tips-img {
            flex: 0 0 0.2rem;
            padding: 0 0.1rem;
            img {
              width: 0.2rem;
              height: 0.2rem;
            }
          }
          .tips-text {
            flex: 1;
            line-height: 0.15rem;
            text-align: left;
            font-size: 0.12rem;
            font-weight: bold;
            color: #181818;
          }
        }
      }
    }
    .shopmall-list {
      padding: 0.1rem 0 0.2rem 0.1rem;
      background: #fff;
      .shopmall-navbar {
        display: flex;
        border-bottom: 0.01rem solid #f1f1f1;
        .barcolor {
          color: #F62E2E !important;
        }
        .navbar {
          flex: 1;
          position: relative;
          padding: 0.1rem 0;
          font-size: 0.14rem;
          font-weight: bold;
          color: #181818;
          text-align: center;
          span {
            font-weight: bold;
          }
          .stortop {
            position: absolute;
            top: 0.09rem;
            right: 0.4rem;
            display: inline-block;
            width: 0;
            height: 0;
            border-left: 0.03rem solid transparent;
            border-right: 0.03rem solid transparent;
            border-bottom: 0.07rem solid #181818;
          }
          .storbottom {
            position: absolute;
            bottom: 0.09rem;
            right: 0.4rem;
            display: inline-block;
            width: 0;
            height: 0;
            border-left: 0.03rem solid transparent;
            border-right: 0.03rem solid transparent;
            border-top: 0.07rem solid #181818;
          }
          .topcolor {
            border-bottom: 0.07rem solid #F62E2E;
          }
          .bottomcolor {
            border-top: 0.07rem solid #F62E2E;
          }
        }
      }
      .shopmall-box {
        display: flex;
        padding-bottom: 0.1rem;
        border-bottom: 0.01rem solid #f1f1f1;
        &:last-child {
          border-bottom: 0;
        }
        .shopmall-img {
          flex: 0 0 1.2rem;
          padding-top: 0.1rem;
          text-align: center;
          background: #fafafa;
          font-size: 0;
          img {
            width: 1rem;
            height: 1rem;
          }
        }
        .shopmall-info {
          flex: 1;
          position: relative;
          margin-left: 0.1rem;
          text-align: left;
          .shopmall-flex {
            position: absolute;
            bottom: 0;
          }
          .shopmall-title {
            padding-top: 0.05rem;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            word-wrap: break-word;
            white-space: normal !important;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            font-size: 0.14rem;
            font-weight: bold;
            color: #000;
          }
          .shopmall-price {
            padding: 0.1rem 0 0;
            font-size: 0.12rem;
            color: #F62E2E;
            span {
              font-size: 0.16rem;
              font-weight: bold;
              color: #F62E2E;
            }
            strong {
              margin-left: 0.1rem;
              text-decoration:line-through;
              font-size: 0.12rem;
              color: #9B9B9B;
            }
          }
          .shopmall-number {
            padding: 0.05rem 0;
            font-size: 0.12rem;
            color: #9B9B9B;
          }
          .shopmall-company {
            display: flex;
            .company-img {
              flex: 0 0 0.18rem;
              height: 0.18rem;
              align-self: center;
              img {
                width: 0.18rem;
                height: 0.18rem;
              }
            }
            .company-text {
              flex: 1;
              margin-left: 0.05rem;
              align-self: center;
              font-size: 0.12rem;
              color: #181818;
            }
          }
        }
      }
    }
    .shopmall-height {
      height: 0.5rem;
    }
    .shopmall-app {
      position: fixed;
      bottom: 0;
      width:  3.75rem;
      height: 0.8rem;
      background: #fff;
      text-align: center;
      font-size: 0;
      .app-img {
        display: inline-block;
        margin-top: 0.1rem;
        width: 90%;
        // padding: 0 0.05rem;
        // height: 0.54rem;
        img {
          width: 100%;
        }
      }
      .msgbox-botton {
        position: relative;
        display: inline-block;
        width: 90%;
        height: 0.45rem;
        margin-top: 0.1rem;
        background: linear-gradient(147deg,#ff6666 30%, #f82a19 76%);
        border-radius: 0.04rem;
        font-size: 0.15rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        line-height: 0.45rem;
        strong {
          margin-left: 0.2rem;
        }
        .launch-btn {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
          opacity: 0;
        }
      }
    }
  }
</style>
